(() => {
  const desktopQuery = window.matchMedia('(min-width: 750px)');
  const disclosureSelector = '#FacetFiltersForm .facets__disclosure';

  const closeOtherDisclosures = (current = null) => {
    document.querySelectorAll(`${disclosureSelector}[open]`).forEach((details) => {
      if (details !== current) details.removeAttribute('open');
    });
  };

  document.addEventListener('click', (event) => {
    if (!desktopQuery.matches) return;

    const summary = event.target.closest(`${disclosureSelector} > summary`);
    if (summary) {
      closeOtherDisclosures(summary.parentElement);
      return;
    }

    if (!event.target.closest(disclosureSelector)) {
      closeOtherDisclosures();
    }
  });

  desktopQuery.addEventListener?.('change', (event) => {
    if (!event.matches) closeOtherDisclosures();
  });
})();
